export default __webpack_public_path__ + "static/media/home_banner_logged_In.a9fb4a7f.jpg";